import { useEffect, useState } from 'react';
import { Appointment } from '../../../../core/models/appointment';
import { AppointmentWidget } from '../appointment-widget/appointment-widget';
import './appointment-header.scss';
import { AppointmentStatus } from '../../../../core/models/appointment-status.enum';
import { useTranslation } from 'react-i18next';

type AppointmentHeaderProps = {
	appointments: Appointment[];
};

export const AppointmentHeader: React.FC<AppointmentHeaderProps> = ({ appointments }) => {
	const { t } = useTranslation();

	const [totalAppointments, setTotalAppointments] = useState<number>(0);
	const [totalAcceptedAppointments, setTotalAcceptedAppointments] = useState<number>(0);
	const [totalRequestedAppointments, setTotalRequestedAppointments] = useState<number>(0);
	const [totalCustomers, setTotalCustomers] = useState<number>(0);

	useEffect(() => {
		setTotalAppointments(appointments.length);
		setTotalAcceptedAppointments(appointments.filter((x) => x.status === AppointmentStatus.ACCEPTED).length);
		setTotalRequestedAppointments(appointments.filter((x) => x.status === AppointmentStatus.REQUEST).length);

		setTotalCustomers(countTotalCustomers());
	}, [appointments]);

	const countTotalCustomers = (): number => {
		const uniqueCustomers = new Set<number>();

		appointments.forEach((appointment) => {
			if (appointment.customer) {
				uniqueCustomers.add(appointment.customer.id);
			}
		});

		return uniqueCustomers.size;
	};

	return (
		<div className='appointment-header'>
			<AppointmentWidget title={t('backEnd.appointment.totalAppointments')} counter={totalAppointments} />
			<AppointmentWidget title={t('backEnd.appointment.acceptedAppointments')} counter={totalAcceptedAppointments} color='#4dcb8c' />
			<AppointmentWidget title={t('backEnd.appointment.requestedAppointments')} counter={totalRequestedAppointments} color='#F5AE41' />
			<AppointmentWidget title={t('common.customer')} counter={totalCustomers} color='#D436C4' />
		</div>
	);
};
